import { generateUtilityClasses } from '../../utils';

export const detailPageSkeletonClasses = generateUtilityClasses('DetailPageSkeleton', [
  'root',
  'header',
  'anchorTabs',
  'content',
  'contentSection',
  'contentSectionHeader',
]);
